// family based configuration
const familyConfig = {
	default: {
		skipConfigurationEngine: false,
		defaultProductFamily: '',
		forceOverview: false,
		hideOverview: true,
		hasWizard: false,
		noDimming: false,
		hideDownloadButtons: true
	},
	TheLine: {
		label: {
			de: 'Line (Stahl)',
			en: 'Line (Steel)',
			fr: 'Line (Acier)',
		},
		isConfigurator: true,
		skipConfigurationEngine: false,
		defaultProductFamily: 'TheLine',
		forceOverview: false,
		hideOverview: false,
		hasWizard: false,
		productInfoUrl: '/products/line',
		createShortNumber: true,
		noDimming: true,
		configurator: 'TheLine',
		attributes: {
			mounting: ['system', 'pole'],
			lightProfile: ['AdjustingWhite'],
			facets: ['smartcity', 'wood']
		}
	},
	LightProfile: {
		label: {
			de: 'Lichtprofil',
			en: 'Light Profile',
			fr: 'Profil lumineux',
		},
		isConfigurator: true,
		skipConfigurationEngine: true,
		defaultProductFamily: '',
		forceOverview: false,
		hideOverview: true,
		hasWizard: false,
		productInfoUrl: '/circulare-lichtprofile',
		createShortNumber: false,
		noDimming: true,
		configurator: 'LightProfile',
		attributes: {
			mounting: [],
			lightProfile: ['AdjustingWhite'],
			facets: []
		}
	},
	Aeto: {
		label: {
			de: 'Aeto',
			en: 'Aeto',
			fr: 'Aeto',
		},
		isConfigurator: true,
		image: 'aeto.jpg',
		skipConfigurationEngine: false,
		defaultProductFamily: 'Aeto',
		forceOverview: false,
		hideOverview: true,
		hasWizard: false,
		productInfoUrl: '/products/aeto',
		createShortNumber: true,
		noDimming: true,
		configurator: 'Aeto',
		maintenance: false,
		attributes: {
			mounting: ['system', 'pole'],
			lightProfile: ['AdjustingWhite'],
			facets: []
		}
	},
	Olivio: {
		label: {
			de: 'Olivio',
			en: 'Olivio',
			fr: 'Olivio',
		},
		isConfigurator: true,
		image: 'olivio.jpg',
		skipConfigurationEngine: false,
		defaultProductFamily: 'Olivio',
		forceOverview: false,
		hideOverview: true,
		hasWizard: false,
		productInfoUrl: '/products/olivio',
		createShortNumber: false,
		noDimming: false,
		configurator: 'Olivio',
		accessoryUrl: '/products/olivio/accessories',
		attributes: {
			mounting: ['system', 'pole', 'lightColumns', 'bollards', 'wallMounted'],
			lightProfile: ['AdjustingWhite'],
			facets: ['nightsky', 'smartcity', 'wood', 'gobo']
		}
	},


	Line: {
		label: {
			de: 'Line',
			en: 'Line',
			fr: 'Line',
		},
		isConfigurator: false,
		image: 'line.jpg',
		skipConfigurationEngine: false,
		defaultProductFamily: 'TheLine',
		forceOverview: false,
		hideOverview: false,
		hasWizard: true,
		productInfoUrl: '/products/line',
		createShortNumber: true,
		noDimming: false,
		configurator: 'TheLine',
		attributes: {
			mounting: ['system', 'pole'],
			lightProfile: ['AdjustingWhite'],
			facets: ['smartcity', 'wood']
		}
	},
	Aeto2: {
		label: {
			de: 'Aeto',
			en: 'Aeto',
			fr: 'Aeto',
		},
		isConfigurator: false,
		image: 'aeto.jpg',
		skipConfigurationEngine: false,
		defaultProductFamily: 'Aeto',
		forceOverview: false,
		hideOverview: true,
		hasWizard: true,
		productInfoUrl: '/products/aeto',
		createShortNumber: false,
		noDimming: true,
		configurator: 'Aeto',
		attributes: {
			mounting: ['system', 'pole'],
			lightProfile: ['AdjustingWhite'],
			facets: ['nightsky', 'solar']
		}
	},
	Olivio2: {
		label: {
			de: 'Olivio',
			en: 'Olivio',
			fr: 'Olivio',
		},
		isConfigurator: false,
		image: 'olivio.jpg',
		skipConfigurationEngine: false,
		defaultProductFamily: 'Olivio',
		forceOverview: true,
		hideOverview: true,
		hasWizard: true,
		productInfoUrl: '/products/olivio',
		createShortNumber: false,
		noDimming: false,
		configurator: 'Olivio',
		accessoryUrl: '/products/olivio/accessories',
		attributes: {
			mounting: ['system', 'pole', 'lightColumns', 'bollards', 'wallMounted'],
			lightProfile: ['AdjustingWhite'],
			facets: ['nightsky', 'smartcity', 'wood', 'gobo']
		}
	},
	Lif2: {
		label: {
			de: 'Lif',
			en: 'Lif',
			fr: 'Lif',
		},
		isConfigurator: false,
		image: 'lif.jpg',
		skipConfigurationEngine: false,
		defaultProductFamily: 'Lif',
		forceOverview: true,
		hideOverview: true,
		hasWizard: true,
		productInfoUrl: '/products/lif',
		createShortNumber: false,
		noDimming: false,
		accessoryUrl: '/products/lif/accessories',
		attributes: {
			mounting: ['system', 'lightColumns', 'wallMounted'],
			lightProfile: ['AdjustingWhite'],
			facets: ['nightsky', 'smartcity', 'zhaga', 'tritec', 'gobo']
		}
	},
	Avanza: {
		label: {
			de: 'Avanza',
			en: 'Avanza',
			fr: 'Avanza',
		},
		isConfigurator: false,
		image: 'avanza.jpg',
		skipConfigurationEngine: false,
		defaultProductFamily: 'Avanza',
		forceOverview: true,
		hideOverview: true,
		hasWizard: true,
		productInfoUrl: '/products/avanza',
		accessoryUrl: '/products/avanza/accessories',
		createShortNumber: false,
		noDimming: false,
		attributes: {
			mounting: ['pole', 'poleTopLuminaires', 'lateralLuminaires', 'wallMounted'],
			lightProfile: ['BiologicalRed', 'BiologicalWhite', 'AdjustingWhite'],
			facets: ['nightsky', 'smartcity', 'zhaga']
		}
	},
	Lanova: {
		label: {
			de: 'Lanova',
			en: 'Lanova',
			fr: 'Lanova',
		},
		isConfigurator: false,
		image: 'lanova.jpg',
		skipConfigurationEngine: false,
		defaultProductFamily: 'Lanova',
		forceOverview: true,
		hideOverview: true,
		hasWizard: true,
		productInfoUrl: '/products/lanova',
		createShortNumber: false,
		noDimming: false,
		accessoryUrl: '/products/lanova/accessories',
		attributes: {
			mounting: ['pole'],
			lightProfile: ['DynamicAmbiance'],
			facets: []
		}
	},
	Tal: {
		label: {
			de: 'Tal',
			en: 'Tal',
			fr: 'Tal',
		},
		isConfigurator: false,
		image: 'tal.jpg',
		skipConfigurationEngine: false,
		defaultProductFamily: 'Tal',
		forceOverview: true,
		hideOverview: true,
		hasWizard: true,
		productInfoUrl: '/products/tal',
		createShortNumber: false,
		noDimming: false,
		attributes: {
			mounting: ['pole', 'poleTopLuminaires', 'lateralLuminaires'],
			lightProfile: ['BiologicalRed', 'BiologicalWhite', 'AdjustingWhite'],
			facets: ['nightsky', 'smartcity', 'zhaga']
		}
	},
	Saturn: {
		label: {
			de: 'Saturn',
			en: 'Saturn',
			fr: 'Saturn',
		},
		isConfigurator: false,
		image: 'saturn.jpg',
		skipConfigurationEngine: false,
		defaultProductFamily: 'Saturn',
		forceOverview: true,
		hideOverview: true,
		hasWizard: true,
		productInfoUrl: '/products/saturn',
		createShortNumber: false,
		noDimming: false,
		accessoryUrl: '/products/saturn/accessories',
		attributes: {
			mounting: ['pole', 'poleTopLuminaires', 'bollards'],
			lightProfile: ['BiologicalRed', 'BiologicalWhite', 'AdjustingWhite'],
			facets: ['tritec', 'classic']
		}
	},
	Aya: {
		label: {
			de: 'Aya',
			en: 'Aya',
			fr: 'Aya',
		},
		isConfigurator: false,
		image: 'aya.jpg',
		skipConfigurationEngine: false,
		defaultProductFamily: 'Aya',
		forceOverview: true,
		hideOverview: true,
		hasWizard: true,
		productInfoUrl: '/products/aya',
		createShortNumber: false,
		noDimming: false,
		accessoryUrl: '/products/aya/accessories',
		attributes: {
			mounting: ['pole', 'polePendantLuminaires', 'catenaryLuminaires'],
			lightProfile: ['BiologicalRed', 'BiologicalWhite', 'AdjustingWhite'],
			facets: ['nightsky', 'smartcity', 'zhaga']
		}
	},
	Yloo: {
		label: {
			de: 'Yloo',
			en: 'Yloo',
			fr: 'Yloo',
		},
		isConfigurator: false,
		image: 'yloo.jpg',
		skipConfigurationEngine: false,
		defaultProductFamily: 'Yloo',
		forceOverview: true,
		hideOverview: true,
		hasWizard: true,
		productInfoUrl: '/products/yloo',
		createShortNumber: false,
		noDimming: false,
		accessoryUrl: '/products/yloo/accessories',
		attributes: {
			mounting: ['pole'],
			lightProfile: ['DynamicPath'],
			facets: []
		}
	},
	Aira: {
		label: {
			de: 'Aira',
			en: 'Aira',
			fr: 'Aira',
		},
		isConfigurator: false,
		image: 'aira.jpg',
		skipConfigurationEngine: false,
		defaultProductFamily: 'Aira',
		forceOverview: true,
		hideOverview: true,
		hasWizard: true,
		productInfoUrl: '/products/aira',
		createShortNumber: false,
		noDimming: false,
		accessoryUrl: '/products/aira/accessories',
		attributes: {
			mounting: ['pole', 'poleTopLuminaires', 'polePendantLuminaires', 'catenaryLuminaires'],
			lightProfile: ['AdjustingWhite'],
			facets: ['nightsky', 'smartcity', 'zhaga', 'gobo']
		}
	},
	Alpha: {
		label: {
			de: 'Alpha',
			en: 'Alpha',
			fr: 'Alpha',
		},
		isConfigurator: false,
		image: 'alpha.jpg',
		skipConfigurationEngine: false,
		defaultProductFamily: 'Alpha',
		forceOverview: true,
		hideOverview: true,
		hasWizard: true,
		productInfoUrl: '/products/alpha',
		createShortNumber: false,
		noDimming: false,
		accessoryUrl: '/products/alpha/accessories',
		attributes: {
			mounting: ['pole', 'poleTopLuminaires'],
			lightProfile: ['AdjustingWhite'],
			facets: ['tritec', 'classic']
		}
	},
	Anatar: {
		label: {
			de: 'Anatar',
			en: 'Anatar',
			fr: 'Anatar',
		},
		isConfigurator: false,
		image: 'anatar.jpg',
		skipConfigurationEngine: false,
		defaultProductFamily: 'Anatar',
		forceOverview: true,
		hideOverview: true,
		hasWizard: true,
		productInfoUrl: '/products/anatar',
		createShortNumber: false,
		noDimming: false,
		accessoryUrl: '/products/anatar/accessories',
		attributes: {
			mounting: ['pole', 'lateralLuminaires'],
			lightProfile: ['AdjustingWhite'],
			facets: ['nightsky', 'solar', 'smartcity']
		}
	},
	Arca: {
		label: {
			de: 'Arca',
			en: 'Arca',
			fr: 'Arca',
		},
		isConfigurator: false,
		image: 'arca.jpg',
		skipConfigurationEngine: false,
		defaultProductFamily: 'Arca',
		forceOverview: true,
		hideOverview: true,
		hasWizard: true,
		productInfoUrl: '/products/arca',
		createShortNumber: false,
		noDimming: false,
		accessoryUrl: '/products/arca/accessories',
		attributes: {
			mounting: ['pole', 'wallMounted'],
			lightProfile: ['AdjustingWhite'],
			facets: ['nightsky']
		}
	},
	Astro: {
		label: {
			de: 'Astro',
			en: 'Astro',
			fr: 'Astro',
		},
		isConfigurator: false,
		image: 'astro.jpg',
		skipConfigurationEngine: false,
		defaultProductFamily: 'Astro',
		forceOverview: true,
		hideOverview: true,
		hasWizard: true,
		productInfoUrl: '/products/astro',
		createShortNumber: false,
		noDimming: false,
		accessoryUrl: '/products/astro/accessories',
		attributes: {
			mounting: ['pole', 'poleTopLuminaires'],
			lightProfile: ['AdjustingWhite'],
			facets: ['nightsky', 'smartcity', 'zhaga']
		}
	},
	Axeo: {
		label: {
			de: 'Axeo',
			en: 'Axeo',
			fr: 'Axeo',
		},
		isConfigurator: false,
		image: 'axeo.jpg',
		skipConfigurationEngine: false,
		defaultProductFamily: 'Axeo',
		forceOverview: true,
		hideOverview: true,
		hasWizard: true,
		productInfoUrl: '/products/axeo',
		createShortNumber: false,
		noDimming: false,
		attributes: {
			mounting: [],
			lightProfile: ['AdjustingWhite'],
			facets: []
		}
	},
	Beta: {
		label: {
			de: 'Beta',
			en: 'Beta',
			fr: 'Beta',
		},
		isConfigurator: false,
		image: 'beta.jpg',
		skipConfigurationEngine: false,
		defaultProductFamily: 'Beta',
		forceOverview: true,
		hideOverview: true,
		hasWizard: true,
		productInfoUrl: '/products/beta',
		createShortNumber: false,
		noDimming: false,
		attributes: {
			mounting: ['pole', 'poleTopLuminaires', 'polePendantLuminaires'],
			lightProfile: ['AdjustingWhite'],
			facets: ['classic']
		}
	},
	Discera: {
		label: {
			de: 'Discera',
			en: 'Discera',
			fr: 'Discera',
		},
		isConfigurator: false,
		image: 'discera.jpg',
		skipConfigurationEngine: false,
		defaultProductFamily: 'Discera',
		forceOverview: true,
		hideOverview: true,
		hasWizard: true,
		productInfoUrl: '/products/discera',
		createShortNumber: false,
		noDimming: false,
		accessoryUrl: '/products/discera/accessories',
		attributes: {
			mounting: ['pole', 'poleTopLuminaires', 'lateralLuminaires', 'wallMounted'],
			lightProfile: ['AdjustingWhite'],
			facets: ['classic']
		}
	},
	Elo: {
		label: {
			de: 'Elo',
			en: 'Elo',
			fr: 'Elo',
		},
		isConfigurator: false,
		image: 'elo.jpg',
		skipConfigurationEngine: false,
		defaultProductFamily: 'Elo',
		forceOverview: true,
		hideOverview: true,
		hasWizard: true,
		productInfoUrl: '/products/elo',
		createShortNumber: false,
		noDimming: false,
		accessoryUrl: '/products/elo/accessories',
		attributes: {
			mounting: ['pole', 'poleTopLuminaires', 'lightColumns', 'bollards', 'wallMounted'],
			lightProfile: ['AdjustingWhite'],
			facets: ['nightsky', 'tritec']
		}
	},
	Inula: {
		label: {
			de: 'Inula',
			en: 'Inula',
			fr: 'Inula',
		},
		isConfigurator: false,
		image: 'inula.jpg',
		skipConfigurationEngine: false,
		defaultProductFamily: 'Inula',
		forceOverview: true,
		hideOverview: true,
		hasWizard: true,
		productInfoUrl: '/products/inula',
		createShortNumber: false,
		noDimming: false,
		accessoryUrl: '/products/inula/accessories',
		attributes: {
			mounting: ['lightColumns', 'bollards'],
			lightProfile: ['AdjustingWhite'],
			facets: ['nightsky']
		}
	},
	Jessica: {
		label: {
			de: 'Jessica',
			en: 'Jessica',
			fr: 'Jessica',
		},
		isConfigurator: false,
		image: 'jessica.jpg',
		skipConfigurationEngine: false,
		defaultProductFamily: 'Jessica',
		forceOverview: true,
		hideOverview: true,
		hasWizard: true,
		productInfoUrl: '/products/jessica',
		createShortNumber: false,
		noDimming: false,
		accessoryUrl: '/products/jessica/accessories',
		attributes: {
			mounting: ['pole', 'lateralLuminaires', 'wallMounted'],
			lightProfile: ['AdjustingWhite'],
			facets: ['classic']
		}
	},
	Lif: {
		label: {
			de: 'Lif',
			en: 'Lif',
			fr: 'Lif',
		},
		isConfigurator: false,
		image: 'lif.jpg',
		skipConfigurationEngine: false,
		defaultProductFamily: 'Lif',
		forceOverview: true,
		hideOverview: true,
		productInfoUrl: '/products/lif',
		createShortNumber: false,
		noDimming: false,
		accessoryUrl: '/products/lif/accessories',
		attributes: {
			mounting: ['system', 'lightColumns'],
			lightProfile: ['AdjustingWhite'],
			facets: ['nightsky', 'smartcity', 'zhaga', 'tritec', 'gobo']
		}
	},
	Lukida: {
		label: {
			de: 'Lukida',
			en: 'Lukida',
			fr: 'Lukida',
		},
		isConfigurator: false,
		image: 'lukida.jpg',
		skipConfigurationEngine: false,
		defaultProductFamily: 'Lukida',
		forceOverview: true,
		hideOverview: true,
		hasWizard: true,
		productInfoUrl: '/products/lukida',
		createShortNumber: false,
		noDimming: true,
		attributes: {
			mounting: ['lightColumns'],
			lightProfile: ['AdjustingWhite'],
			facets: ['nightsky', 'solar', 'smartcity']
		}
	},
	Mistella: {
		label: {
			de: 'Mistella',
			en: 'Mistella',
			fr: 'Mistella',
		},
		isConfigurator: false,
		image: 'mistella.jpg',
		skipConfigurationEngine: false,
		defaultProductFamily: 'Mistella',
		forceOverview: true,
		hideOverview: true,
		hasWizard: true,
		productInfoUrl: '/products/mistella',
		createShortNumber: false,
		noDimming: false,
		attributes: {
			mounting: ['pole', 'poleTopLuminaires'],
			lightProfile: ['AdjustingWhite'],
			facets: ['nightsky', 'smartcity', 'zhaga']
		}
	},
	Rondero: {
		label: {
			de: 'Rondero',
			en: 'Rondero',
			fr: 'Rondero',
		},
		isConfigurator: false,
		image: 'rondero.jpg',
		skipConfigurationEngine: false,
		defaultProductFamily: 'Rondero',
		forceOverview: true,
		hideOverview: true,
		hasWizard: true,
		productInfoUrl: '/products/rondero',
		createShortNumber: false,
		noDimming: false,
		accessoryUrl: '/products/rondero/accessories',
		attributes: {
			mounting: ['pole', 'poleTopLuminaires'],
			lightProfile: ['AdjustingWhite'],
			facets: ['tritec', 'classic']
		}
	},
	Sombreo: {
		label: {
			de: 'Sombreo',
			en: 'Sombreo',
			fr: 'Sombreo',
		},
		isConfigurator: false,
		image: 'sombreo.jpg',
		skipConfigurationEngine: false,
		defaultProductFamily: 'Sombreo',
		forceOverview: true,
		hideOverview: true,
		hasWizard: true,
		productInfoUrl: '/products/sombreo',
		createShortNumber: false,
		noDimming: false,
		accessoryUrl: '/products/sombreo/accessories',
		attributes: {
			mounting: ['pole', 'polePendantLuminaires', 'catenaryLuminaires', 'wallMounted'],
			lightProfile: ['AdjustingWhite'],
			facets: ['classic']
		}
	},
	Tessia: {
		label: {
			de: 'Tessia',
			en: 'Tessia',
			fr: 'Tessia',
		},
		isConfigurator: false,
		image: 'tessia.jpg',
		skipConfigurationEngine: false,
		defaultProductFamily: 'Tessia',
		forceOverview: true,
		hideOverview: true,
		hasWizard: true,
		productInfoUrl: '/products/tessia',
		createShortNumber: false,
		noDimming: false,
		accessoryUrl: '/products/tessia/accessories',
		attributes: {
			mounting: ['pole', 'poleTopLuminaires', 'lateralLuminaires'],
			lightProfile: ['AdjustingWhite'],
			facets: ['nightsky', 'smartcity', 'zhaga']
		}
	},
	Trigo: {
		label: {
			de: 'Trigo',
			en: 'Trigo',
			fr: 'Trigo',
		},
		isConfigurator: false,
		image: 'trigo.jpg',
		skipConfigurationEngine: false,
		defaultProductFamily: 'Trigo',
		forceOverview: true,
		hideOverview: true,
		hasWizard: true,
		productInfoUrl: '/products/trigo',
		createShortNumber: false,
		noDimming: false,
		attributes: {
			mounting: ['pole', 'poleTopLuminaires'],
			lightProfile: ['AdjustingWhite'],
			facets: ['nightsky']
		}
	},
	Valetta: {
		label: {
			de: 'Valetta',
			en: 'Valetta',
			fr: 'Valetta',
		},
		isConfigurator: false,
		image: 'valetta.jpg',
		skipConfigurationEngine: false,
		defaultProductFamily: 'Valetta',
		forceOverview: true,
		hideOverview: true,
		hasWizard: true,
		productInfoUrl: '/products/valetta',
		createShortNumber: false,
		noDimming: true,
		attributes: {
			mounting: ['pole'],
			lightProfile: ['BiologicalRed', 'BiologicalWhite', 'AdjustingWhite'],
			facets: ['solar', 'wood']
		}
	},
	TritecReplacementKits: {
		label: {
			de: 'Tritec Replacement Kits',
			en: 'Tritec Replacement Kits',
			fr: 'Tritec Replacement Kits',
		},
		isConfigurator: false,
		image: 'tritec.jpg',
		skipConfigurationEngine: false,
		defaultProductFamily: 'TritecReplacementKits',
		forceOverview: true,
		hideOverview: true,
		hasWizard: true,
		productInfoUrl: '/products/tritec',
		createShortNumber: false,
		noDimming: false,
		attributes: {
			mounting: [],
			lightProfile: ['AdjustingWhite'],
			facets: ['tritec']
		}
	},
	Start: {
		label: {
			de: 'Selux',
			en: 'Selux',
			fr: 'Selux',
		},
		skipConfigurationEngine: true,
		defaultProductFamily: '',
		forceOverview: true,
		hideOverview: true,
		createShortNumber: false,
		attributes: {
			mounting: [],
			lightProfile: ['AdjustingWhite'],
			facets: []
		}
	},
};

export function getFamilyConfig(family) {
	return familyConfig[family] ?? familyConfig.default;
}

export default familyConfig;
